import React, { Component, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Axios from "axios";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "./AddBookList.css";
import { url } from "../../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class AddBookList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        title: "",
        numberOfCopies: 0,
        author: "",
        ISBN: "",
        publication: "",
        category: "",
      },
      ref: {
        isbnRef: createRef(),
        copiesRef: createRef(),
      },
      error: {
        bookError: "",
        copiesError: "",
        isbnError: "",
        authorError: "",
      },
      loading: false,
    };
  }

  componentDidMount() {
    if (this.props.editStatus) {
      this.setData(this.props.data);
    }
  }

  setData = (data) => {
    this.setState({
      data: {
        ...this.state.data,
        title: data.title,
        numberOfCopies: data.numberOfCopies,
        author: data.author,
        ISBN: data.ISBN,
        publication: data.publication ? data.publication : "",
        category: data.category ? data.category : "",
      },
    });
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleWheel = (refValue) => {
    refValue.current.blur();
    setTimeout(() => refValue.current.focus(), 100);
  };

  filterData = (data) => {
    let changedData = data;
    if (changedData.publication === "") {
      delete changedData.publication;
    }

    if (changedData.category === "") {
      delete changedData.category;
    }
    return changedData;
  };

  checkError = () => {
    let bookError = "";
    let copiesError = "";
    let isbnError = "";
    let authorError = "";

    if (this.state.data.title === "") {
      bookError = "Book Title must be inserted";
    }

    if (this.state.data.numberOfCopies <= 0) {
      copiesError = "Number of Copies must be greater than 0";
    }

    if (this.state.data.ISBN === "") {
      isbnError = "ISBN must be inserted";
    }

    if (this.state.data.author === "") {
      authorError = "Author name must be inserted";
    }

    if (bookError || copiesError || isbnError || authorError) {
      this.setState({
        error: {
          bookError,
          copiesError,
          isbnError,
          authorError,
        },
      });
      return true;
    } else {
      this.setState({
        error: {
          bookError: "",
          copiesError: "",
          isbnError: "",
          authorError: "",
        },
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        let data = this.filterData(this.state.data);
        if (this.props.editStatus) {
          const response = await Axios.put(
            `${url}/api/books/${this.props.bookId}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${this.props.adminToken}`,
              },
            }
          );
          if (response.data.message === "Book edited successfully") {
            this.props.handleCancelEdit();
            this.props.getBookList();
          }
        } else {
          const response = await Axios.post(`${url}/api/books`, data, {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          });
          if (response.data.message === "Book added successfully") {
            this.setState({
              data: {
                title: "",
                numberOfCopies: 0,
                author: "",
                ISBN: "",
                publication: "",
                category: "",
              },
              loading: false,
            });
            this.props.getBookList();
          }
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <TableRow>
        <TableCell />
        <TableCell align="center">
          <TextField
            name="title"
            type="text"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="Book Title"
            error={this.state.error.bookError ? true : false}
            helperText={this.state.error.bookError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.title}
            onChange={this.handleChange}
          />
        </TableCell>

        <TableCell align="center" colSpan={2}>
          <TextField
            name="numberOfCopies"
            type="number"
            label="Total Copies"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="Copies available"
            error={this.state.error.copiesError ? true : false}
            helperText={this.state.error.copiesError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              inputProps: {
                min: 0,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            inputRef={this.state.ref.copiesRef}
            onWheel={() => this.handleWheel(this.state.ref.copiesRef)}
            value={this.state.data.numberOfCopies}
            onChange={this.handleChange}
          />
        </TableCell>

        <TableCell align="center">
          <TextField
            name="ISBN"
            type="number"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="Book's ISBN"
            error={this.state.error.isbnError ? true : false}
            helperText={this.state.error.isbnError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            inputRef={this.state.ref.isbnRef}
            onWheel={() => this.handleWheel(this.state.ref.isbnRef)}
            value={this.state.data.ISBN}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="author"
            type="text"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="Book's Author"
            error={this.state.error.authorError ? true : false}
            helperText={this.state.error.authorError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.author}
            onChange={this.handleChange}
          />
        </TableCell>

        <TableCell align="center">
          <TextField
            name="category"
            type="text"
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="Book's Category"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.category}
            onChange={this.handleChange}
          />
        </TableCell>

        <TableCell align="center">
          <TextField
            name="publication"
            type="text"
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="Publication Name"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.publication}
            onChange={this.handleChange}
          />
        </TableCell>

        <TableCell align="center">
          {this.props.editStatus ? (
            <>
              <Tooltip
                arrow
                title="Update"
                className={classes.tooltip}
                onClick={this.handleSubmit}
              >
                <CheckCircleIcon />
              </Tooltip>
              <Tooltip
                arrow
                title="Cancel"
                className={classes.tooltip}
                onClick={this.props.handleCancelEdit}
              >
                <CancelIcon />
              </Tooltip>
            </>
          ) : (
            <Tooltip
              arrow
              title="Add"
              className={classes.tooltip}
              onClick={this.handleSubmit}
            >
              <AddCircleIcon />
            </Tooltip>
          )}
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddBookList)));
